import styled from "styled-components";
import { spacer } from "modules/theme";
import { responsive, Container } from "styled-minimal";

export const HeaderWrapper = styled.header`
  color: black;
  height: 100%;
`;

export const HeaderContainer = styled(Container)`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  padding: 0;
  // padding-bottom: ${spacer(2)};
  // padding-top: ${spacer(2)};
`;

export const Actions = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-direction: column;
  width: 200px;
`;

export const Action = styled.button`
  align-items: center;
  // color: rgb(232, 119, 34);
  color: black;
  display: flex;
  font-size: 1.5rem;
  padding: ${spacer(3)};
  gap: 16px;
  text-align: left;
  width: 100%;

  // ${responsive({ md: { fontSize: '1.6rem' } })}; /* stylelint-disable-line */

  &:hover {
    background-color: white;
  }
  span {
    display: inline-block;
    margin-right: 0.4rem;
    text-transform: none;
  }

  .icon {
    border-radius: 50px;
    min-width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(232, 119, 34);
    margin-right: 8px;
    border: 3px solid transparent;
    color: white;
  }

  // &:hover .icon {
  //   background-color: #999;
  // }

  // &:active .icon {
  //   color: rgb(232, 119, 34);
  //   background-color: white;
  // }
`;